import React from "react";
import "./Protocol.css";

// Import images dynamically
import image1 from "../Assets/asset.jpeg";
import image2 from "../Assets/asset.jpeg";
import image3 from "../Assets/asset.jpeg";
import image4 from "../Assets/asset.jpeg";
import image5 from "../Assets/asset.jpeg";
import image6 from "../Assets/asset.jpeg";
import image7 from "../Assets/asset.jpeg";

const Protocol = () => {
  // Data for cards
  const cards = [
    { id: 1, title: "Card 1", image: image1 },
    { id: 2, title: "Card 2", image: image2 },
    { id: 3, title: "Card 3", image: image3 },
    { id: 4, title: "Card 4", image: image4 },
    { id: 5, title: "Card 5", image: image5 },
    { id: 6, title: "Card 6", image: image6 },
    { id: 7, title: "Card 7", image: image7 },
  ];

  return (
    <div className="protocol-container">
      <h1 className="main-title">Best Education Wordpress Themes</h1>
      <div className="grid-container">
        {cards.map((card) => (
          <div key={card.id} className="prot">
            <img src={card.image} alt={card.title} className="prot-image" />
            <div className="prot-overlay">
              <h2 className="prot-title">{card.title}</h2>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Protocol;
